(function(angular, _) {
    'use strict';

    angular.module('wtApp.dataService')
        .factory('WtPredefinedAnalysis', ['WtAnalysis', function(WtAnalysis) {
            /**
             * @ngdoc service
             * @name WtPredefinedAnalysis
             * @description Represents the analyses predefined by webtrekk
             */
            return class WtPredefinedAnalysis extends WtAnalysis {
                /**
                 * @ngdoc property
                 * @name WtPredefinedAnalysis#menuPath
                 * @description A map of the analysis' menu item parents
                 * @returns {Array<string>}
                 */
                get menuPath() {
                    return _.map(this.menuPath_);
                }

                constructor() {
                    super(...arguments);

                    /**
                     * List of the analysis' menu item parents
                     * @type {Array<string>}
                     * @private
                     */
                    this.menuPath_ = [];

                    // Adds older browsers support (IE < 11)
                    this.constructor = this.constructor || WtPredefinedAnalysis;
                }
            };
        }]);
})(window.angular, window._);
